{
  "zh-TW": {
    "actions": {
      "admin": {
        "dashboard": {
          "reloadModels": "重新載入模型",
          "reloadScData": "重新載入 SC 資料",
          "reloadPaints": "重新載入塗裝",
          "reloadModules": "重新載入模組",
          "reloadLoaners": "重新載入借用船"
        },
        "supporterContributions": {
          "syncFromPatreon": "從 Patreon 同步"
        },
        "imports": {
          "cleanup": "標記為失敗",
          "cleanupSelected": "將所選標記為失敗"
        }
      },
      "duplicate": "複製",
      "showReleased": "顯示舊版本",
      "hideReleased": "隱藏舊版本",
      "upgrade": "更新可用！",
      "backToHome": "規劃新航線",
      "disableGrouping": "停用分組",
      "enableGrouping": "啟用分組",
      "groupedByModel": "按型號分組",
      "ungrouped": "未分組",
      "destroyAccount": "刪除帳戶",
      "saveScreenshot": "儲存為PNG",
      "resolve": "解決",
      "verify": "驗證",
      "clearHistory": "清除歷史記錄",
      "sortBy": "排序方式",
      "back": "返回",
      "open": "開啟",
      "copy": "複製",
      "more": "更多...",
      "showMore": "顯示更多",
      "export": "匯出",
      "exportHangarLink": "匯出至 hangar.link",
      "import": "匯入",
      "here": "這裡",
      "backToList": "返回列表",
      "backToTop": "返回頂部",
      "previous": "上一個",
      "next": "下一個",
      "cancel": "取消",
      "ok": "確定",
      "reset": "重置",
      "reload": "重新載入",
      "confirm": "確認",
      "moreInfo": "更多資訊",
      "showDetailPage": "詳情頁面",
      "showDetails": "顯示詳情",
      "hideDetails": "隱藏詳情",
      "showGuide": "顯示指南",
      "hideGuide": "隱藏指南",
      "showFleetchart": "艦隊圖表",
      "hideFleetchart": "預設檢視",
      "fleetchartApp": {
        "useExtendedState": "顯示展開狀態的飛船",
        "useRetractedState": "顯示收合狀態的飛船"
      },
      "showLabels": "顯示標籤",
      "hideLabels": "隱藏標籤",
      "resetZoom": "重置縮放",
      "supportUs": "支援FleetYards.net",
      "supportHint": {
        "cta": "支援 FleetYards",
        "later": "稍後再說"
      },
      "login": "登入",
      "signUp": "註冊",
      "confirmAccess": "確認密碼",
      "sendConfirmAccessEmail": "傳送確認郵件",
      "reset-password": "忘記密碼？",
      "edit": "編輯",
      "clear": "清除",
      "done": "完成",
      "share": "分享",
      "change": "更改",
      "upload": "上傳",
      "save": "儲存",
      "enable": "啟用",
      "disable": "停用",
      "manage": "管理",
      "enableGlobally": "全域啟用",
      "disableGlobally": "全域停用",
      "addActor": "新增角色",
      "addGroup": "新增群組",
      "editGroup": "編輯群組",
      "remove": "移除",
      "reorder": "重新排序",
      "delete": "刪除",
      "deleteSelected": "刪除選中項",
      "enableSelected": "啟用選中項",
      "disableSelected": "停用選中項",
      "close": "關閉",
      "filter": "篩選",
      "showStatusColor": "顯示狀態顏色",
      "hideStatusColor": "隱藏狀態顏色",
      "addToHangar": "新增至機庫",
      "resetFilter": "重置篩選器",
      "resetPrices": "重置價格",
      "requestPassword": "請求密碼郵件",
      "changePassword": "更改密碼",
      "updatePassword": "更新密碼",
      "copyBackupCodes": "複製備份代碼",
      "regenerate": "重新產生",
      "add": "新增",
      "create": "建立",
      "addToWishlist": "新增至願望清單",
      "addAnother": "新增另一個",
      "addVehicle": "新增飛船",
      "addModule": "新增另一個模組",
      "addUpgrade": "新增另一個升級",
      "showTableView": "顯示為清單",
      "showGridView": "顯示為網格",
      "linkExisting": "連結現有",
      "loadMore": "載入更多",
      "unlink": "取消連結",
      "syncRsiHangar": "同步RSI機庫",
      "oauthApplications": {
        "create": "新增應用程式",
        "regenerateSecret": "重新產生密鑰"
      },
      "oauthAuthorize": {
        "authorize": "授權",
        "deny": "拒絕"
      },
      "verifyWithCitizenId": "使用 Citizen iD 驗證",
      "oauth": {
        "signInWith": "透過以下方式登入",
        "google": "Google",
        "discord": "Discord",
        "bluesky": "BlueSky",
        "github": "GitHub",
        "twitch": "Twitch",
        "citizenid": "Citizen iD",
        "connected": {
          "google": "已連接到 Google",
          "discord": "已連接到 Discord",
          "bluesky": "已連接到 BlueSky",
          "github": "已連接到 GitHub",
          "twitch": "已連接到 Twitch",
          "citizenid": "已連接到 Citizen iD"
        },
        "disconnect": {
          "google": "中斷 Google 連線",
          "discord": "中斷 Discord 連線",
          "bluesky": "中斷 BlueSky 連線",
          "github": "中斷 GitHub 連線",
          "twitch": "中斷 Twitch 連線",
          "citizenid": "中斷 Citizen iD 連線"
        }
      },
      "compare": {
        "ships": "對比"
      },
      "cargoGrids": {
        "addShips": "新增飛船"
      },
      "hangar": {
        "editGroups": "Add or remove Groups",
        "editName": "Name your Ship",
        "manageLoadouts": "管理配置",
        "manageCargo": "管理貨物",
        "backToHangar": "返回機庫",
        "useName": "Use Name",
        "destroyAll": "Remove all Ships",
        "showOnPublicHangar": "Make Public",
        "hideFromPublicHangar": "Hide from Public",
        "editGroupsSelected": "Add/Remove from Groups",
        "resetIngame": {
          "openModal": "資料重置後重設遊戲內飛船",
          "moveToWishlist": "Move to Wishlist",
          "removeAll": "Remove all"
        }
      },
      "syncExtension": {
        "cancel": "取消",
        "start": "Start Sync",
        "retry": "重試同步",
        "close": "關閉",
        "refresh": "重新整理頁面"
      },
      "empty": {
        "hangarGuide": "Need Help?",
        "reset": "清除篩選"
      },
      "destroyFleet": "解散艦隊",
      "restore": "還原",
      "fleet": {
        "join": "Join %{fleet}!",
        "leave": "Leave %{fleet}",
        "createInviteUrl": "Create Invite Urls",
        "inviteMember": "Invite new Member",
        "manageInvites": "邀請",
        "worldmap": "世界地圖",
        "starmap": "星圖",
        "membersList": "成員",
        "acceptInvite": "Accept Invitation",
        "declineInvite": "Decline Invitation",
        "acceptRequest": "accept Request",
        "declineRequest": "Decline Request",
        "showOwners": "More",
        "members": {
          "invite": "Invite",
          "promote": "Promote",
          "demote": "Demote",
          "accept": "Accept",
          "decline": "Decline",
          "remove": "移除",
          "editRole": "編輯角色"
        },
        "inviteUrls": {
          "create": "Create new Invite Url"
        },
        "discord": {
          "test": "測試 Discord 連線",
          "installBot": "在你的 Discord 伺服器安裝 Fleetyards 機器人"
        },
        "calendarSubscription": {
          "enable": "產生訂閱連結",
          "rotate": "更換連結",
          "disable": "停用訂閱"
        }
      },
      "model": {
        "gallery": "Gallery",
        "onSale": "On Sale: %{price}",
        "store": "RSI Page"
      },
      "models": {
        "sync": "從 RSI 同步",
        "syncMatrix": "同步矩陣",
        "syncScData": "同步 SC 資料",
        "importPaints": "匯入塗裝",
        "exchangeStoreImage": "使用 RSI 圖片",
        "images": "圖片",
        "openTableConfiguration": "開啟表格設定"
      },
      "users": {
        "loginAs": "以使用者身分登入",
        "resendConfirmation": "重新傳送確認",
        "sendPasswordReset": "傳送密碼重設"
      },
      "unselect": "Unselect all Selected",
      "openPriceModal": "Submit Price",
      "twoFactor": {
        "enable": "Enable Two-factor",
        "disable": "Disable Two-factor",
        "generateBackupCodes": "產生備用碼"
      },
      "holoViewer": {
        "autoRotate": {
          "enable": "Enable auto rotate",
          "disable": "Disable auto rotate"
        },
        "zoom": {
          "enable": "Enable zoom",
          "disable": "Disable zoom"
        },
        "color": {
          "enable": "Enable colors",
          "disable": "Disable colors"
        }
      },
      "roadmap": {
        "showRemoved": "Show Removed",
        "hideRemoved": "Hide Removed"
      },
      "logistics": {
        "viewRequests": "View Requests",
        "newRequest": "New Request",
        "createRequest": "Create Request",
        "createInventory": "New Inventory",
        "submit": "Submit",
        "approve": "Approve",
        "reject": "Reject",
        "startWork": "Start Work",
        "fulfill": "Fulfill",
        "cancel": "Cancel",
        "addComment": "Add Comment",
        "deposit": "Deposit",
        "withdraw": "Withdraw",
        "createItem": "Add Item",
        "importCsv": "Import CSV",
        "downloadTemplate": "Download Template",
        "destroyInventory": "Delete Inventory",
        "destroyEntry": "Delete Entry",
        "editStockItem": "Edit Item",
        "destroyStockItem": "Delete Item",
        "editInventory": "Edit Inventory",
        "clearCargo": "清空貨物",
        "viewCargoGrid": "檢視貨艙網格"
      },
      "adminNotifications": {
        "unread": "標示為未讀",
        "archive": "封存",
        "unarchive": "移回收件匣",
        "readAll": "全部標示為已讀",
        "destroyAll": "全部刪除",
        "sortOldest": "最舊的優先",
        "sortNewest": "最新的優先",
        "select": "選取通知",
        "readSelected": "將選取項目標示為已讀",
        "unreadSelected": "將選取項目標示為未讀",
        "archiveSelected": "封存選取項目",
        "unarchiveSelected": "將選取項目移回收件匣",
        "destroySelected": "刪除選取項目"
      },
      "account": {
        "calendarSubscription": {
          "enable": "產生個人行事曆連結",
          "rotate": "更換連結",
          "disable": "停用訂閱"
        }
      },
      "today": "今天",
      "fleets": {
        "missions": {
          "create": "建立任務",
          "edit": "編輯任務",
          "archive": "封存任務",
          "unarchive": "取消封存",
          "destroy": "永久刪除",
          "addTeam": "新增隊伍",
          "addShip": "新增飛船",
          "addSlot": "新增席位",
          "viewMissions": "檢視任務"
        },
        "events": {
          "create": "建立活動",
          "edit": "編輯活動",
          "spawn": "從此任務建立活動",
          "archive": "封存活動",
          "unarchive": "從封存還原",
          "syncToDiscord": "同步至 Discord",
          "destroy": "永久刪除",
          "publish": "發布",
          "lockSignups": "鎖定報名",
          "unlockSignups": "解除報名鎖定",
          "start": "開始",
          "complete": "完成",
          "cancel": "取消",
          "signup": "報名",
          "withdraw": "取消報名",
          "kick": "移除報名",
          "viewEvents": "檢視活動",
          "viewCalendar": "檢視行事曆",
          "exportIcs": "匯出 iCal",
          "addToCalendar": "加入行事曆",
          "subscribe": "訂閱",
          "setUpCalendar": "設定行事曆訂閱",
          "assignSlot": "指派席位",
          "reassignSlot": "移至其他席位",
          "addSeats": "新增座位",
          "manageEventTeam": "管理活動團隊",
          "grantRole": "授予角色",
          "revokeRole": "撤銷",
          "editSchedule": "編輯隊伍與飛船",
          "doneEditing": "完成編輯",
          "addTeam": "新增隊伍"
        }
      },
      "notifications": {
        "unread": "標示為未讀",
        "archive": "封存",
        "unarchive": "移回收件匣",
        "readAll": "全部標示為已讀",
        "destroyAll": "全部刪除",
        "settings": "通知設定",
        "sortOldest": "最舊的優先",
        "sortNewest": "最新的優先",
        "openCenter": "通知",
        "select": "選取通知",
        "readSelected": "將選取項目標示為已讀",
        "unreadSelected": "將選取項目標示為未讀",
        "archiveSelected": "封存選取項目",
        "unarchiveSelected": "將選取項目移回收件匣",
        "destroySelected": "刪除選取項目"
      },
      "unlistedModel": {
        "createModel": "建立飛船",
        "markAsPaint": "這是塗裝",
        "ignore": "忽略",
        "noManufacturer": "此識別碼無法解析出製造商",
        "alreadyExists": "%{name} 已在目錄中",
        "link": "已在目錄中",
        "markAsPaintSelected": "將所選標記為塗裝",
        "ignoreSelected": "忽略所選"
      },
      "revert": "還原",
      "exportCsv": "匯出 CSV",
      "exportAllCsv": "全部匯出為 CSV"
    }
  }
}
